import React, { Component } from "react";
import ToggleDrawer from "../containers/ToggleDrawer";
import styles from "../../../assets/css/modules/shared/label-with-tooltip.css";
import TooltipIcon from "../form/TooltipIcon";

class LabelWithTooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toolTipVisible: false
    };
  }

  onClick = () => {
    this.setState({
      toolTipVisible: !this.state.toolTipVisible
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className={"row " + styles.labelWithTooltip}>
          {this.props.mfa? 
          <>
          <div className={"col-12 " + styles.labelmfa}>{this.props.label}
            {this.props.tooltipContent ? (
              <TooltipIcon
                customStyle={styles.tooltipIconMFA}
                onToggle={this.onClick}
                mfa={this.props.mfa}
              />
            ) : null}
          </div></>:
          <><div className={"col-11 " + styles.label}>{this.props.label}</div>
          <div className="col-1">
            {this.props.tooltipContent ? (
              <TooltipIcon
                customStyle={styles.tooltipIcon}
                onToggle={this.onClick}
              />
            ) : null}
          </div></>}
        </div>
        {this.props.mfa? <ToggleDrawer isOpen={this.state.toolTipVisible}>
          <div className={styles.tooltipTextmfa}>
            {this.props.tooltipContent}
          </div>
        </ToggleDrawer>:
        <ToggleDrawer isOpen={this.state.toolTipVisible}>
          <div className={"input-tooltip " + styles.tooltipText}>
            {this.props.tooltipContent}
          </div>
        </ToggleDrawer>}
      </React.Fragment>
    );
  }
}

export default LabelWithTooltip;
